var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJersey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 400,
    viewBox: "0 0 500 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 422.5 160 L 423.5 162 L 422.5 160 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 75.5 161 L 74.5 163 L 75.5 161 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 72.5 163 L 71.5 165 L 72.5 163 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 427.5 163 L 428.5 165 L 427.5 163 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 430.5 165 L 431.5 167 L 430.5 165 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,143,129)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 22 L 175.5 22 Q 196.606 36.394 225.5 43 Q 241.563 46.438 262.5 45 Q 300.139 40.139 324.5 22 L 343.5 22 L 344.5 23 L 381.5 23 L 483 94.5 L 453 174.5 L 450.5 178 L 372 129 Q 369.9 133.85 371 143.5 L 370 144.5 L 370 156.5 L 369 157.5 Q 371.75 166.75 368 169.5 L 368 181.5 L 367 182.5 Q 369.75 191.75 366 194.5 L 366 206.5 L 365 207.5 L 364 231.5 L 363 232.5 L 362 256.5 L 361 257.5 Q 358.882 319.942 352 377 L 148.5 377 Q 147.125 376.625 148 369.5 L 147 368.5 Q 149.75 359.25 146 356.5 L 146 344.5 L 145 343.5 Q 147.75 334.25 144 331.5 L 144 319.5 L 143 318.5 Q 145.75 309.25 142 306.5 L 142 294.5 L 141 293.5 Q 143.75 284.25 140 281.5 L 140 269.5 L 139 268.5 Q 141.75 259.25 138 256.5 L 138 244.5 L 137 243.5 Q 139.75 234.25 136 231.5 L 136 219.5 L 135 218.5 Q 137.75 209.25 134 206.5 L 134 194.5 Q 128.966 166.034 129 132.5 L 128 129 L 49.5 178 L 19 99.5 L 18 93.5 L 118.5 23 L 153.5 23 L 154.5 22 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.f29dc757079a08599723d85dade123d8.svg";
export { ForwardRef as ReactComponent };